import {
  type RoomConnectionDescriptorResource,
  type RoomSessionResource,
  type RoomSessionStatusResource,
  type RoomSourceResource,
  type RoomStatusResource,
} from '@/features/messaging/api/resources/rooms'
import { type RoomStatus, type RoomSource } from './Room'
import { type RoomConnectionDescriptor } from './connection-descriptor'
import { type RoomSessionStatus, type RoomSessionProps } from './RoomSession'

/**
 * Maps a call held in a room.
 */
export function mapRoomSessionResourceToProps(
  resource: RoomSessionResource,
): RoomSessionProps {
  return {
    id: resource.id,
    dateStarted: resource.date_started,
    dateModified: resource.date_modified,
    status: mapRoomSessionStatusResourceToStatus(resource.status),
  }
}

/**
 * Maps whether a room is open for calls.
 */
export function mapRoomStatusResourceToStatus(
  status: RoomStatusResource,
): RoomStatus {
  switch (status) {
    case 'ACTIVE':
      return 'Active'
    case 'CLOSED':
      return 'Closed'
  }
  // The API may send values this build doesn't know yet.
  return 'Unknown'
}

/**
 * Maps the service that hosts a room.
 */
export function mapRoomSourceResourceToSource(
  source: RoomSourceResource,
): RoomSource {
  switch (source.type) {
    case 'Whereby':
      return { type: 'Whereby' }
    case 'Local':
      return { type: 'Local' }
  }
  return { type: 'Unknown' }
}

function mapRoomSessionStatusResourceToStatus(
  status: RoomSessionStatusResource,
): RoomSessionStatus {
  switch (status) {
    case 'ACTIVE':
      return 'Active'
    case 'ENDED':
      return 'Ended'
  }
  return 'Unknown'
}

/**
 * Maps how to connect to a room.
 */
export function mapRoomConnectionDescriptorResourceToProps(
  descriptor: RoomConnectionDescriptorResource,
): RoomConnectionDescriptor {
  switch (descriptor.type) {
    case 'Whereby':
      return {
        type: 'Whereby',
        roomUrl: descriptor.room_url,
      }
    case 'Local':
      return {
        type: 'Local',
      }
  }
}
